import React from "react";

/**
 * Cover the YouTube iframe with the DJ Gabo Karaoke logo as soon as a song ends,
 * to hide YouTube's "suggested videos" grid.
 *
 * mode = "inline" (player panel) | "fullscreen" (2nd screen)
 */
const EndOfVideoOverlay = ({ mode = "inline" }) => {
  const positioning = mode === "fullscreen" ? "fixed inset-0 z-40" : "absolute inset-0 z-25";

  return (
    <div
      className={`${positioning} flex flex-col items-center justify-center bg-black/92 backdrop-blur-md animate-presentation-in overflow-hidden`}
      data-testid="end-of-video-overlay"
    >
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(circle at 50% 50%, rgba(var(--glow-rgb),0.18), transparent 55%)",
        }}
      />
      <div className="absolute inset-0 grain pointer-events-none" />

      <img
        src="/logo-dj-gabo.png"
        alt="DJ Gabo Karaoke"
        data-testid="end-of-video-logo"
        className={`relative z-10 h-auto object-contain ${mode === "fullscreen" ? "w-[min(60vw,60vh)]" : "w-[min(45%,45vh)]"}`}
      />
    </div>
  );
};

export default EndOfVideoOverlay;
